import { createContext } from 'react'

import type { IconListSize } from './icon-list'

export type IconListContextType = {
  size: IconListSize
}

export const IconListContext = createContext<IconListContextType>({
  size: 'md',
})
